import React from "react";
import BaseComponent from "../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";
import { elementMatchesAny, linkifyText } from "../../Global/tools.js";

import Input from "../../Nano/Input.js";
import Grid from "../../Macro/Grid.js";
import WrapperList from "./../../Nano/WrapperList.js";
import ViewMore from "./../../Nano/ViewMore.js";
import Modal from "../../Global/Modal.js";
import DeleteContent from "../../Micro/DeleteContent.js";
import UnlinkContent from "../../Micro/UnlinkContent.js";
import Spinner from "../../Nano/Spinner.js";
import EditPlaylistModal from "../../Micro/EditPlaylistModal.js";
import SharePlaylistModal from "../../Micro/SharePlaylistModal.js";
import UnlinkPlaylistModal from "../../Micro/UnlinkPlaylistModal.js";

//IMAGES
import { ReactComponent as SearchIcon } from "../../Global/Icons/search.svg";
import { ReactComponent as Edit } from "../../Global/Icons/edit.svg";
import { ReactComponent as Duplicate } from "../../Global/Icons/duplicate.svg";
import { ReactComponent as Delete } from "../../Global/Icons/delete.svg";
import { ReactComponent as Share } from "../../Global/Icons/share.svg";
import { ReactComponent as Eye } from "../../Global/Icons/eye.svg";
import { ReactComponent as EyeClosed } from "../../Global/Icons/eyeClosed.svg";
import { ReactComponent as Unlink } from "../../Global/Icons/unlink.svg";
import { ReactComponent as Link } from "../../Global/Icons/link.svg";
import { ReactComponent as CreatDate } from "../../Global/Icons/createDate.svg";
import { ReactComponent as EditDate } from "../../Global/Icons/editDate.svg";
import Loading from "./../../Nano/Loading.js";

//SERVICES
import playlistService from "../../../services/PlaylistService.js";

const multiple = nota.global.multiple;

const StyledPlaylistsManagement = styled(NanoFlex)`
  height: 100%;
  padding: ${multiple * 2 + "px"};
  .headerWrapper {
    height: auto;
    h2 {
      text-transform: uppercase;
      em {
        text-transform: none;
        font-weight: bold;
        color: ${nota.color.main.default};
      }
    }
    p {
      margin-left: ${multiple * 2 + "px"};
      margin-bottom: 2px;
    }
  }
  .secondaryWrapper {
    height: auto;
    margin: ${multiple * 3 + "px"} 0;
    .optionsWrapper {
      width: auto;
    }
  }

  /* INPUT --- secondaryWrapper */
  .inputWrapper {
    width: 360px;
    position: relative;
    .inputContainer {
      width: 100%;
      margin: 0;
      input {
        padding-right: 40px;
      }
    }
    .searchIconWrapper {
      position: absolute;
      right: ${multiple + "px"};
      top: 0;
      width: ${multiple * 3 + "px"};
      svg {
        width: 18px;
        height: 18px;
        path {
          fill: ${nota.color.main.default};
        }
      }
    }
  }

  /* TOGGLE BTN --- secondaryWrapper */
  .toggleBtnContainer {
    cursor: pointer;
    background-color: ${nota.color.neutral.lightGrey};
    border-radius: 50px;
    padding: 11px ${multiple * 2 + "px"};
    user-select: none;
    .iconBtnWrapper {
      width: auto;
      svg {
        width: 23px;
        height: auto;
        path {
          fill: ${nota.color.main.default};
        }
      }
    }
    .textBtnWrapper {
      margin-left: ${multiple + "px"};
    }

    &:hover {
      opacity: 0.7;
    }
  }

  /* LIST */
  .listContainer {
    height: auto;

    .itemContainer {
      width: 50%;
      height: auto;

      .wrapperList {
        /* margin: 0; */
        padding: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .headerContainer {
          height: auto;
        }
        .titleCard {
          margin-top: ${multiple * 2 + "px"};
          margin-left: ${multiple * 2 + "px"};
          margin-bottom: ${multiple / 2 + "px"};
          width: 85%;
          height: auto;
          h3 {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
        .descriptionWrapper {
          margin-left: ${multiple * 2 + "px"};
          margin-bottom: ${multiple + "px"};
          width: 85%;
          height: auto;
          p {
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
        }
        .noInfo {
          margin-bottom: ${multiple + "px"};
          font-size: 12px;
          color: ${nota.color.neutral.NeuThree};
          line-height: unset;
          height: auto;
          min-height: 10px;
        }

        .gridContainer {
          min-height: 200px;
          .emptyGrid {
            background-color: ${nota.color.neutral.NeuFour};
            p {
              text-transform: uppercase;
            }
          }
        }

        .grid {
          padding: 0 ${multiple + "px"};
        }

        .bottomOptionsWrapper {
          padding: ${multiple + "px"} ${multiple * 2 + "px"};
          background-color: ${nota.color.neutral.lightGrey};
          height: auto;
          .infoContainer {
            .dateContainer {
              .dateWrapper {
                width: auto;

                svg {
                  width: auto;
                  height: 12px;
                  margin-right: 4px;
                  path {
                    fill: ${nota.color.neutral.NeuOne};
                  }
                }
              }
            }
          }
          .bottomIcons {
            width: 50%;
            height: auto;

            svg {
              width: 14px;
              height: 14px;
              margin: 0 ${multiple + "px"};
              cursor: pointer;
              path {
                fill: ${nota.color.neutral.NeuOne};
              }
              &:hover {
                path {
                  fill: ${nota.color.main.default};
                }
              }
              &:last-child {
                margin-right: 0;
              }
            }
            .deleteBtn {
              &:hover {
                path {
                  fill: ${nota.color.main.mTwo};
                }
              }
            }
            .optionsItem {
              display: flex;
            }
            .optionsItemShared {
              display: none;
            }
          }
        }
      }
      &:nth-child(odd) {
        .wrapperList {
          margin-left: 0;
        }
      }
      &:nth-child(even) {
        .wrapperList {
          margin-right: 0;
        }
      }
    }

    .sharedItem {
      .wrapperList {
        border: 1px solid ${nota.color.neutral.NeuOne};
        border-top: 3px solid ${nota.color.neutral.NeuOne};
        .wrapperViewMore {
          h6 {
            b {
              color: ${nota.color.neutral.NeuOne};
            }
          }
          &:before {
            border-top: 15px solid ${nota.color.neutral.NeuOne};
          }
        }
        .headerContainer {
          .titleCard {
            h3 {
              color: ${nota.color.neutral.NeuOne};
            }
          }
        }
        .bottomOptionsWrapper {
          .userInfo {
            width: auto;
            min-width: 100px;
            margin-right: ${multiple + "px"};
            text-align: right;
          }
          .bottomIcons {
            .optionsItem {
              display: none;
            }
            .optionsItemShared {
              display: flex;
            }
          }
        }
      }
    }
  }
  /* NO ITEMS LIST INFO */
  .noItemsListInfo {
    height: calc(100vh - 242px);
    background-color: ${nota.color.neutral.NeuFour};
    h2 {
      text-transform: uppercase;
    }
  }
  /* MEDIA QUERIES */
  @media only screen and (max-width: 800px) {
    .headerWrapper {
      flex-direction: column;
      align-items: flex-start;
      p {
        margin-top: ${multiple + "px"};
        margin-left: 0px;
        margin-bottom: 0px;
      }
    }
    .secondaryWrapper {
      margin: 24px 0;
      .inputWrapper {
        width: 100%;
      }
      .optionsWrapper {
        margin-left: 8px;
        .toggleBtnContainer {
          padding: 11px 8px;
          .textBtnWrapper {
            display: none;
          }
        }
      }
    }
    .listContainer {
      .itemContainer {
        flex-direction: column;
        width: 100%;
        .wrapperList {
          margin: 0 0 16px 0;
          .infoContainer {
            flex-direction: column;
            .programmesNumber {
              justify-content: flex-start;
            }
          }
          &.last-child {
            margin: 0;
          }
        }
      }
    }
    .noItemsListInfo {
      height: calc(100vh - 307px);
    }
  }
  @media only screen and (max-width: 1000px) {
    .listContainer {
      .itemContainer {
        .wrapperList {
          .bottomOptionsWrapper {
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-end;
            .infoContainer {
              flex-direction: column;
              justify-content: flex-start;
              align-items: flex-start;
              .programmesNumber {
                justify-content: flex-start;
                align-content: flex-start;
              }
            }
            .bottomIcons {
              width: 100%;
              margin-top: ${multiple / 2 + "px"};
            }
          }
        }
      }
    }
  }
`;
const StyledLoading = styled(NanoFlex)`
  height: calc(100vh - 98px);
`;

export class PlaylistItem extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      programs: null,
      count: null,
      showUnlink: false,
      showOwnersUnlink: false,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onPlaylistItemLanguageChange, false);

    this.getAllData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.requestId !== this.props.requestId) {
      this.getPrograms();
    }
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("languageChange", this.onPlaylistItemLanguageChange, false);
  }

  onPlaylistItemLanguageChange = () => {
    this.getAllData();
  };

  getAllData = () => {
    this.getPrograms();
  };

  getPrograms = () => {
    if (this.props.playlist.programCount > 0) {
      playlistService
        .getPlaylistsPrograms(this.props.playlist.id, 7)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            // Catch
            if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
          }
        })
        .then((data) => {
          this.setState({ programs: data.programs, count: data.count });
        });
    } else {
      this.setState({ programs: [], count: 0 });
    }
  };

  canShow = () => {
    let termValid = true;
    let hideValid = true;
    if (this.props.term.trim() !== "") {
      let upperTerm = this.props.term.trim().toUpperCase();
      let upperName = this.props.playlist.name.trim().toUpperCase();
      termValid = upperName.includes(upperTerm);
    }
    if (this.props.hideShared && this.props.playlist.isShared) hideValid = false;

    return termValid && hideValid;
  };

  onDeleteClick = () => {
    if (this.props.onDelete) {
      this.props.onDelete(this.props.playlist);
    }
  };

  onDuplicateClick = () => {
    if (this.props.onDuplicate) {
      this.props.onDuplicate(this.props.playlist);
    }
  };

  onEditClick = () => {
    if (this.props.onEdit) {
      this.props.onEdit(this.props.playlist);
    }
  };

  onUnlinkClick = () => {
    if (this.props.onUnlink) {
      this.props.onUnlink(this.props.playlist);
    }
  };

  onShareClick = () => {
    if (this.props.onShare) {
      this.props.onShare(this.props.playlist);
    }
  };

  onViewMoreClick = (e) => {
    if (elementMatchesAny(e.target, ["a"])) return;
    window.dispatchEvent(new CustomEvent("setSearchFrom", { detail: { menu: "Playlist", id: this.props.playlist.id } }));
  };

  onOwnerUnlinkClick = () => {
    this.setState({ showUnlink: true });
  };

  render() {
    if (this.canShow() == false) return null;

    return (
      <NanoFlex className={`itemContainer ${this.props.playlist.isShared ? "sharedItem" : ""}`} key={this.props.playlist.id} alignItems={"stretch"}>
        <WrapperList className="wrapperList">
          <ViewMore onClick={this.onViewMoreClick} />

          <NanoFlex className="headerContainer" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"} onClick={this.onViewMoreClick}>
            <NanoFlex className="titleCard" justifyContent={"flex-start"}>
              <Type.h3 title={this.props.playlist.name}>
                <b>{this.props.playlist.name}</b>
              </Type.h3>
            </NanoFlex>
            <NanoFlex className="descriptionWrapper" justifyContent={"flex-start"}>
              {this.props.playlist.description && <Type.p title={this.props.playlist.description} dangerouslySetInnerHTML={{ __html: linkifyText(this.props.playlist.description) }}></Type.p>}
              {!this.props.playlist.description && <Type.p className="noInfo"> </Type.p>}
            </NanoFlex>
          </NanoFlex>

          <NanoFlex className="gridContainer">
            {this.state.programs?.length > 0 && (
              <NanoFlex>
                <Grid className="gridItem" data={this.state.programs} row={1} />
              </NanoFlex>
            )}

            {this.state.programs?.length == 0 && (
              <NanoFlex className="emptyGrid">
                <Type.p>No items</Type.p>
              </NanoFlex>
            )}

            {!this.state.programs && (
              <NanoFlex className="loadingGrid">
                <Spinner />
              </NanoFlex>
            )}
          </NanoFlex>

          <NanoFlex className="bottomOptionsWrapper">
            <NanoFlex className="infoContainer">
              <NanoFlex className="dateContainer" flexDirection={"column"} justifyContent={"flex-start"} alignItems={"flex-start"}>
                <NanoFlex className="dateWrapper" justifyContent={"flex-start"}>
                  <CreatDate />
                  <Type.p>{this.props.playlist.creationDate}</Type.p>
                </NanoFlex>
                <NanoFlex className="dateWrapper" justifyContent={"flex-start"}>
                  <EditDate />
                  <Type.p>{this.props.playlist.date}</Type.p>
                </NanoFlex>
              </NanoFlex>
              <NanoFlex className="programmesNumber">
                <Type.p>
                  {this.state.count ?? "-"} {this.state.count > 1 ? this.translation.geral.programmes : this.translation.geral.programme}
                </Type.p>
              </NanoFlex>
            </NanoFlex>

            <NanoFlex className="bottomIcons" justifyContent={"flex-end"}>
              {!this.props.playlist.isShared && (
                <NanoFlex className="optionsItem" justifyContent={"flex-end"}>
                  {this.state.showOwnersUnlink && <Link title="Shared" onClick={this.onOwnerUnlinkClick} />}
                  <Share title={this.translation.geral.share} onClick={this.onShareClick} />
                  <Edit title={this.translation.geral.edit} onClick={this.onEditClick} />
                  <Duplicate title={this.translation.geral.duplicate} onClick={this.onDuplicateClick} />
                  <Delete title={this.translation.geral.continue} className="deleteBtn" onClick={this.onDeleteClick} />
                </NanoFlex>
              )}
              {this.props.playlist.isShared && (
                <NanoFlex className="optionsItemShared" justifyContent={"flex-end"}>
                  <NanoFlex className="userInfo" flexDirection={"column"} justifyContent={"flex-end"} alignItems={"flex-end"} alignContent={"flex-end"}>
                    <Type.h6>{this.translation.geral.sharedBy}</Type.h6>
                    <Type.h6>{this.props.playlist.username}</Type.h6>
                  </NanoFlex>
                  <Duplicate title={this.translation.geral.duplicate} onClick={this.onDuplicateClick} />
                  <Unlink title={this.translation.geral.unlinkShare} className="deleteBtn" onClick={this.onUnlinkClick} />
                </NanoFlex>
              )}
            </NanoFlex>
          </NanoFlex>
        </WrapperList>

        <Modal
          show={this.state.showUnlink}
          content={
            <UnlinkPlaylistModal
              playlistId={this.props.playlist.id}
              onUsersChange={(users) => {
                this.setState({ showOwnersUnlink: users.length > 0 });
              }}
              cancelAction={() => {
                this.setState({ showUnlink: false });
              }}
              nextAction={() => {
                this.setState({ showUnlink: false });
              }}
            />
          }
        />
      </NanoFlex>
    );
  }
}

export class PlaylistsManagement extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      term: "",
      playlists: null,
      playlistToEdit: null,
      playlistToDelete: null,
      playlistToUnlink: null,
      playlistToShare: null,
      requestId: 0,
      hideShared: false,
      isDuplicating: false,
    };
  }

  componentDidMount() {
    super.componentDidMount();
    window.addEventListener("languageChange", this.onPlaylistsLanguageChange, false);
    window.addEventListener("playlistsChange", this.onPlaylistsChange, false);

    this.getAllComponentsData();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
    window.removeEventListener("languageChange", this.onPlaylistsLanguageChange, false);
    window.removeEventListener("playlistsChange", this.onPlaylistsChange, false);
  }

  onPlaylistsLanguageChange = () => {
    this.getAllComponentsData();
  };

  onPlaylistsChange = () => {
    this.getAllComponentsData();
  };

  getAllComponentsData = () => {
    this.getPlaylists();
  };

  getPlaylists = () => {
    playlistService
      .getPlaylists(true, true)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ playlists: data, requestId: this.state.requestId + 1 });
      });
  };

  onTermChange = (value) => {
    this.setState({ term: value });
  };

  onPlaylistDelete = (item) => {
    this.setState({ playlistToDelete: item });
  };

  confirmPlaylistDelete = () => {
    playlistService
      .deletePlaylist(this.state.playlistToDelete.id)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ playlistToDelete: null }, () => {
          /*Trigger playlistsChange Event */
          window.dispatchEvent(new Event("playlistsChange"));
        });
      });
  };

  onPlaylistDuplicate = (item) => {
    this.setState({ isDuplicating: true }, () => {
      playlistService
        .duplicatePlaylist(item.id)
        .then((response) => {
          if (response.ok) {
            return response.json();
          } else {
            // Catch
            if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
          }
        })
        .then((data) => {
          this.setState({ isDuplicating: false }, () => {
            /*Trigger playlistsChange Event */
            window.dispatchEvent(new Event("playlistsChange"));
          });
        });
    });
  };

  onPlaylistEdit = (item) => {
    this.setState({ playlistToEdit: item });
  };

  toggleShared = () => {
    this.setState({ hideShared: !this.state.hideShared });
  };

  onPlaylistUnlink = (item) => {
    this.setState({ playlistToUnlink: item });
  };

  confirmPlaylistUnlink = () => {
    playlistService
      .unlinkSharedPlaylist(this.state.playlistToUnlink.id)
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          // Catch
          if (response.status === 403 || response.status === 401) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        this.setState({ playlistToUnlink: null }, () => {
          /*Get New Data */
          this.getAllComponentsData();
          /*Trigger playlistsChange Event */
          window.dispatchEvent(new Event("playlistsChange"));
        });
      });
  };

  onPlaylistToShare = (item) => {
    this.setState({ playlistToShare: item });
  };

  render() {
    if (this.state.playlists == null || this.state.isDuplicating)
      return (
        <StyledLoading className="loadingContainer">
          <Loading />
        </StyledLoading>
      );

    return (
      <StyledPlaylistsManagement>
        <NanoFlex className="viewWrapper" flexDirection={"column"} justifyContent={"flex-start"}>
          <NanoFlex className="headerWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-end"}>
            <Type.h2>
              <em>{this.translation.playlists.title}</em>
            </Type.h2>
            <Type.p>{this.translation.playlists.subTitle}</Type.p>
          </NanoFlex>

          <NanoFlex className="secondaryWrapper" justifyContent={"space-between"}>
            <NanoFlex className="inputWrapper" justifyContent={"flex-start"} alignContent={"flex-start"} alignItems={"flex-start"}>
              <Input title={null} defaultValue={this.state.term} placeholder={this.translation.playlists.searchPlaylistPlaceholder} onChangeAction={this.onTermChange} />
              <NanoFlex className="searchIconWrapper">
                <SearchIcon />
              </NanoFlex>
            </NanoFlex>
            {this.state.playlists?.some((p) => p.isShared) && (
              <NanoFlex className="optionsWrapper">
                <NanoFlex className="toggleBtnContainer" onClick={this.toggleShared}>
                  <NanoFlex className="iconBtnWrapper">
                    {!this.state.hideShared && <Eye />}
                    {this.state.hideShared && <EyeClosed />}
                  </NanoFlex>
                  <NanoFlex className="textBtnWrapper">
                    {!this.state.hideShared && <Type.p>{this.translation.components.playlistsManagement.hide}</Type.p>}
                    {this.state.hideShared && <Type.p>{this.translation.components.playlistsManagement.show}</Type.p>}
                  </NanoFlex>
                </NanoFlex>
              </NanoFlex>
            )}
          </NanoFlex>

          {/*LIST*/}
          <NanoFlex className="listContainer" flexDirection={"row"} flexWrap={"wrap"} justifyContent={"flex-start"} alignContent={"stretch"} alignItems={"stretch"}>
            {/* ITEM  */}
            {this.state.playlists?.map((item) => {
              return (
                <PlaylistItem
                  playlist={item}
                  key={item.id}
                  requestId={this.state.requestId}
                  term={this.state.term}
                  hideShared={this.state.hideShared}
                  onDuplicate={this.onPlaylistDuplicate}
                  onDelete={this.onPlaylistDelete}
                  onEdit={this.onPlaylistEdit}
                  onUnlink={this.onPlaylistUnlink}
                  onShare={this.onPlaylistToShare}></PlaylistItem>
              );
            })}
            {/* END ITEM  */}
          </NanoFlex>
          {/* END LIST  */}
          {/* EMPTY LIST INFO  */}
          {this.state.playlists?.length == 0 && (
            <NanoFlex className="noItemsListInfo">
              <Type.h2>{this.translation.components.playlistsManagement.emptyList}</Type.h2>
            </NanoFlex>
          )}

          {/* END EMPTY LIST INFO  */}
        </NanoFlex>

        {this.state.playlistToEdit && (
          <Modal
            show={true}
            content={
              <EditPlaylistModal
                playlist={this.state.playlistToEdit}
                cancelAction={() => {
                  this.setState({ playlistToEdit: null });
                }}
                nextAction={() => {
                  this.setState({ playlistToEdit: null }, () => {
                    this.getAllComponentsData();
                  });
                }}
              />
            }
          />
        )}

        {this.state.playlistToDelete && (
          <Modal
            show={true}
            content={
              <DeleteContent
                field={this.state.playlistToDelete.name}
                cancelAction={() => {
                  this.setState({ playlistToDelete: null });
                }}
                nextAction={this.confirmPlaylistDelete}
              />
            }
          />
        )}

        {this.state.playlistToUnlink && (
          <Modal
            show={true}
            content={
              <UnlinkContent
                field={this.state.playlistToUnlink.name}
                cancelAction={() => {
                  this.setState({ playlistToUnlink: null });
                }}
                nextAction={this.confirmPlaylistUnlink}
              />
            }
          />
        )}

        {this.state.playlistToShare && (
          <Modal
            show={true}
            content={
              <SharePlaylistModal
                playlistId={this.state.playlistToShare.id}
                cancelAction={() => {
                  this.setState({ playlistToShare: null });
                }}
                nextAction={() => {
                  this.setState({ playlistToShare: null });
                }}
              />
            }
          />
        )}
      </StyledPlaylistsManagement>
    );
  }
}
